import { render, staticRenderFns } from "./LoginRoute.vue?vue&type=template&id=02860e96"
import script from "./LoginRoute.vue?vue&type=script&lang=ts"
export * from "./LoginRoute.vue?vue&type=script&lang=ts"
import style0 from "./LoginRoute.vue?vue&type=style&index=0&id=02860e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports